/**
 * Created by Ning Jiang on 6/9/2016.
 */
import {Oktoberfest} from "../Oktoberfest";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {Helper} from "@nolimitcity/slot-launcher/bin/utils/Helper";

export class OktoberfestMultiplierIndicatorView extends PIXI.Container {
    private static MULTIPLIER_INTRO = "multiplier-in";
    private static MULTIPLIER_UP = "multiplier-up";
    private static MULTIPLIER_WIN = "multiplier-win";
    private static TL_INTRO_PLAY: string = "introPlay";
    private static TL_INTRO_STOP: string = "introStop";
    private static TL_MULTIPLIER_UP_PLAY: string = "multiplierUpPlay";
    private static TL_MULTIPLIER_UP_STOP: string = "multiplierUpStop";
    private static TL_WIN_START_PLAY: string = "winStartPlay";
    private static TL_WIN_START_STOP: string = "winStartStop";
    private static TL_WIN_END_PLAY: string = "winEndPlay";
    private static TL_WIN_END_STOP: string = "winEndStop";
    private static COIN_POSITION_PORTRAIT: PIXI.Point = new PIXI.Point(660, -735);
    private static MULTIPLIER_TEXT_POSITION: PIXI.Point = new PIXI.Point(6, -7);
    private _multiplierXTextStyle: TextStyleOptions = {
        fontFamily: "Atreyu",
        fontSize: (90 * 0.66) + "px",
        fill: "#fff264",
        stroke: "#281E0B",
        strokeThickness: 2,
        padding: 20
    };
    private _multiplierIndicatorMainLayer: PIXI.Container;
    private _coinIntroMC: TimelineSprite;
    private _coinUpMC: TimelineSprite;
    private _coinWinStartMC: TimelineSprite;
    private _coinWinEndMC: TimelineSprite;
    private _setLevelCompleteCallback: Function | undefined;
    private _multiplierValueTextStyle: TextStyleOptions = {
        fontFamily: "Atreyu",
        fontSize: (102 * 0.66) + "px",
        fill: "#fff264",
        stroke: "#281E0B",
        strokeThickness: 2,
        padding: 20
    };
    private _multiplierText: PIXI.Container;
    private _multiplierTextContainer: PIXI.Container;
    private _currentLevel: number;
    private _multiplierWon: number;
    private _multiplierTotal: number;
    private _multiplierNumberText: PIXI.Text;
    private _multiplierXText: PIXI.Text;
    private _mainTimeline: TimelineMax;
    private _isShowingWin: boolean = false;
    private introCallback: Function;

    constructor() {
        super();
        this.initAnimations();
        this.onResize();
    }
    public onResize(): void {
        if(NolimitApplication.isLandscape) {
            this.setPositions();
        }else{
            this.onPortrait();
        }
    }

    public onAddToStage(data: { playIntro: boolean, completeCallback?: Function }): void {
        this._currentLevel = this._multiplierTotal;
        this.updateMultiplierText();
        this.introCallback = data.completeCallback!;
        //this._multiplierIndicatorMainLayer.addChild(this);
        this.addChild(this._multiplierIndicatorMainLayer);

        if (data.playIntro) {
            this._multiplierIndicatorMainLayer.visible = true;
            this._mainTimeline.tweenFromTo(OktoberfestMultiplierIndicatorView.TL_INTRO_PLAY, OktoberfestMultiplierIndicatorView.TL_INTRO_STOP);
        } else {
            this.updateLevelAnimation({shouldAnimate: false});
            if (this.introCallback) {
                this.introCallback();
            }
        }
    }

    public onRemoveFromStage(): void {
        this.setMCIdleState();
        this._mainTimeline.pause(0);
        this.removeChild(this._multiplierIndicatorMainLayer);
    }

    public updateLevelAnimation(data: { shouldAnimate: boolean, completeCallback?: Function }): void {
        if (!Oktoberfest.model.isRestore) {
            this._multiplierWon = Oktoberfest.model.parsedGameData.addedMultiplierThisSpin;
            this._multiplierTotal = Oktoberfest.model.parsedGameData.multiplierAfterSpin;
        }
        this._multiplierIndicatorMainLayer.visible = true;
        this._setLevelCompleteCallback = data.completeCallback;

        if (this._currentLevel === this._multiplierTotal) {
            this.onLevelUpComplete();
            return;
        }

        if (data.shouldAnimate) {
            this.onMultiplierUp();
        }
        this._currentLevel = this._multiplierTotal;
    }

    protected setPositions(): void {
        const scale: number = NolimitApplication.screenBounds.scale,
            isIpad: boolean = Oktoberfest.isIpad;

        this._coinIntroMC.scale.set(scale, scale);

        this._coinIntroMC.position.x = 0;
        this._coinIntroMC.position.y = 0;

        this._coinUpMC.scale = this._coinIntroMC.scale;
        this._coinUpMC.position = this._coinIntroMC.position;

        this._coinWinStartMC.position = this._coinIntroMC.position;
        this._coinWinStartMC.scale = this._coinIntroMC.scale;

        this._coinWinEndMC.position = this._coinIntroMC.position;
        this._coinWinEndMC.scale = this._coinIntroMC.scale;

        this._multiplierTextContainer.scale = this._coinIntroMC.scale;
        this._multiplierTextContainer.position.y = this._coinIntroMC.position.y + (OktoberfestMultiplierIndicatorView.MULTIPLIER_TEXT_POSITION.y * scale);
        this._multiplierTextContainer.position.x = this._coinIntroMC.position.x + (OktoberfestMultiplierIndicatorView.MULTIPLIER_TEXT_POSITION.x * scale);
        if(isIpad) {
            this._multiplierIndicatorMainLayer.position.set(794, 160);
        } else {
            this._multiplierIndicatorMainLayer.position.set(810, 145);
        }
    }

    protected onPortrait(): void {
        const scale: number = 0.95,
            isIpad: boolean = Oktoberfest.isIpad;

        this._coinIntroMC.scale.set(scale, scale);
        this._coinIntroMC.position.x = OktoberfestMultiplierIndicatorView.COIN_POSITION_PORTRAIT.x * scale;
        this._coinIntroMC.position.y = 0;//NolimitApplication.screenBounds.bottom + (OktoberfestMultiplierIndicatorView.COIN_POSITION_PORTRAIT.y * scale);

        this._coinUpMC.scale = this._coinIntroMC.scale;
        this._coinUpMC.position = this._coinIntroMC.position;

        this._coinWinStartMC.position = this._coinIntroMC.position;
        this._coinWinStartMC.scale = this._coinIntroMC.scale;

        this._coinWinEndMC.position = this._coinIntroMC.position;
        this._coinWinEndMC.scale = this._coinIntroMC.scale;

        this._multiplierTextContainer.scale = this._coinIntroMC.scale;
        if(isIpad) {
            this._multiplierIndicatorMainLayer.position.set(-40, -36);
        } else {
            this._multiplierIndicatorMainLayer.position.set(10, -36);
        }
        this._multiplierTextContainer.position.y = this._coinIntroMC.position.y + (OktoberfestMultiplierIndicatorView.MULTIPLIER_TEXT_POSITION.y * scale);
        this._multiplierTextContainer.position.x = this._coinIntroMC.position.x + (OktoberfestMultiplierIndicatorView.MULTIPLIER_TEXT_POSITION.x * scale);
    }

    private initAnimations(): void {
        this._multiplierWon = 0;
        this._multiplierTotal = Oktoberfest.model.parsedInitData.currentMultiplier;
        this._multiplierIndicatorMainLayer = new PIXI.Container();
        this._multiplierIndicatorMainLayer.visible = false;
        OktoberfestLayers.getLayer(Layers.FS_MULTIPLIER)!.addChild(this);
        this.addChild(this._multiplierIndicatorMainLayer);
        this.createMovieClips();
        this.createText();
        this.createMainTimeline();
        this.setPositions();
    }

    private createMovieClips(): void {
        let anchor: PIXI.Point = new PIXI.Point(0.5, 0.5);

        this._coinIntroMC = new TimelineSprite(Oktoberfest.assetLoader.getTextures(OktoberfestMultiplierIndicatorView.MULTIPLIER_INTRO));
        this._coinIntroMC.anchor.set(anchor.x, anchor.y);
        this._multiplierIndicatorMainLayer.addChild(this._coinIntroMC);

        this._coinUpMC = new TimelineSprite(Oktoberfest.assetLoader.getTextures(OktoberfestMultiplierIndicatorView.MULTIPLIER_UP));
        this._coinUpMC.anchor.set(anchor.x, anchor.y);
        this._multiplierIndicatorMainLayer.addChild(this._coinUpMC);

        this._coinWinStartMC = new TimelineSprite(Oktoberfest.assetLoader.getTextures(OktoberfestMultiplierIndicatorView.MULTIPLIER_WIN));
        this._coinWinStartMC.anchor.set(anchor.x, anchor.y);
        this._multiplierIndicatorMainLayer.addChild(this._coinWinStartMC);
        this._coinWinStartMC.name ="_coinWinStartMC";

        this._coinWinEndMC = new TimelineSprite(Oktoberfest.assetLoader.getTextures(OktoberfestMultiplierIndicatorView.MULTIPLIER_WIN));
        this._coinWinEndMC.anchor.set(anchor.x, anchor.y);
        this._multiplierIndicatorMainLayer.addChild(this._coinWinEndMC);
        this._coinWinEndMC.name ="_coinWinEndMC";
        this.setMCIdleState();
    }

    private setMCIdleState(): void {
        this._coinUpMC.visible = true;
        this._coinIntroMC.visible = false;
        this._coinWinStartMC.visible = false;
        this._coinWinEndMC.visible = false;
    }

    private createText(): void {
        this._multiplierTextContainer = new PIXI.Container;
        this._multiplierIndicatorMainLayer.addChild(this._multiplierTextContainer);

        this._multiplierText = new PIXI.Container;
        this._multiplierTextContainer.addChild(this._multiplierText);

        this._multiplierNumberText = new PIXI.Text("1", this._multiplierValueTextStyle);
        this._multiplierNumberText.anchor.set(0, 0.5);
        this._multiplierNumberText.position.set(-7, -3);
        this._multiplierText.addChild(this._multiplierNumberText);

        this._multiplierXText = new PIXI.Text("x", this._multiplierXTextStyle);
        this._multiplierXText.anchor.set(1, 0.5);
        this._multiplierText.addChild(this._multiplierXText);

        this._multiplierText.pivot.x = ((this._multiplierNumberText.width + this._multiplierXText.width - 7) * 0.5) - this._multiplierXText.width;
    }

    private updateMultiplierText(): void {
        if (Oktoberfest.model.isRestore) {
            this._multiplierTotal = Oktoberfest.model.parsedInitData.currentMultiplier;
        } else {
            this._multiplierTotal = Oktoberfest.model.parsedGameData.multiplierAfterSpin;
        }
        this._multiplierNumberText.text = "" + this._multiplierTotal;
        this._multiplierText.pivot.x = ((this._multiplierNumberText.width + this._multiplierXText.width - 7) * 0.5) - this._multiplierXText.width;
    }

    private createMainTimeline(): void {
        this._mainTimeline = new TimelineMax({paused: true});

        //Intro
        this._mainTimeline.add([
            OktoberfestMultiplierIndicatorView.TL_INTRO_PLAY,
            () => this.playAnimation(this._coinIntroMC),
            new TweenLite(this._multiplierText.scale, 0.001, {x: 0.0, y: 1.0})
        ], this._mainTimeline.totalDuration() + 1);

        this._mainTimeline.add(new TweenLite(this._multiplierText.scale, 7 / 30, {x: 1.0}));
        this._mainTimeline.add(new TweenLite(this._multiplierText.scale, 4 / 30, {x: 0.95}));
        this._mainTimeline.add(new TweenLite(this._multiplierText.scale, 4 / 30, {x: 0.95}));
        this._mainTimeline.add(() => this.onIntroComplete());
        this._mainTimeline.add(OktoberfestMultiplierIndicatorView.TL_INTRO_STOP);
        this._mainTimeline.add(this.onMultiplierUp(), this._mainTimeline.totalDuration() + 1);

        //Multiplier win start(first part of the animation)
        this._mainTimeline.add(this.onShowWin(), this._mainTimeline.totalDuration() + 1);

        //Multiplier win end(second part of the animation)
        this._mainTimeline.add([
            OktoberfestMultiplierIndicatorView.TL_WIN_END_PLAY,
            () => {
            this.playAnimation(this._coinWinEndMC)},
            new TweenLite(this._multiplierText.scale, 0.001, {x: 1.2}),
        ], this._mainTimeline.totalDuration() + 1);
        this._mainTimeline.add(new TweenLite(this._multiplierText.scale, 6 / 30, {
            x: 1.0,
            y: 1.0
        }));
        this._mainTimeline.add(OktoberfestMultiplierIndicatorView.TL_WIN_END_STOP);
        Oktoberfest.scatterMeter.onFreespinLeftAnimationCreated(this._mainTimeline.labels[(OktoberfestMultiplierIndicatorView.TL_MULTIPLIER_UP_STOP)]
            - this._mainTimeline.labels[(OktoberfestMultiplierIndicatorView.TL_MULTIPLIER_UP_PLAY)]);
    }

    private onLevelUpComplete(): void {
        if (this._setLevelCompleteCallback) {
            this._setLevelCompleteCallback();
        }
    }

    private switchVisibleMCTo(mc: TimelineSprite) {
        this._coinIntroMC.visible = false;
        this._coinUpMC.visible = false;
        this._coinWinStartMC.visible = false;
        this._coinWinEndMC.visible = false;
        mc.visible = true;
    }

    private playAnimation(timelineSprite: TimelineSprite): void {
        timelineSprite.getAnimation([0], () => {
        }, () => this.setMCIdleState).timeScale(0.5);
        this.switchVisibleMCTo(timelineSprite);
    }

    private onIntroComplete(): void {
        if (this.introCallback) {
            this.introCallback();
        }
    }

    public onShowWin(): TimelineLite {
        this._isShowingWin = true;
        this.playAnimation(this._coinWinStartMC);
        this._multiplierText.scale.set(1.2,1);
        const tl:TimelineLite= new TimelineLite();
        tl.add(() => {
            OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.SOUND_NAME_FS_MULTIPLIER_WIN});
        }, 0);
        tl.add(new TweenLite(this._multiplierText.scale, 2 / 30, {
            x: 1.0,
            y: 1.0
        }));
        tl.add(new TweenLite(this._multiplierText.scale, 2 / 30, {
            x: 0.8,
            y: 0.8
        }));
        tl.add(new TweenLite(this._multiplierText.scale, 3 / 30, {
            x: 1.2,
            y: 1.2
        }));
        return tl;
    }
    public onMultiplierUp(): TimelineLite {
        //Multiplier up
        this.playAnimation(this._coinUpMC);
        this._multiplierText.scale.set(1);
        const tl:TimelineLite= new TimelineLite();

        tl.add(new TweenLite(this._multiplierText.scale, 14 / 30, {x: 0.72}));
        tl.add(new TweenLite(this._multiplierText.scale, 1 / 30, {x: 1.0}));
        tl.add(new TweenLite(this._multiplierText.scale, 1 / 30, {x: 0.5}));
        tl.add(new TweenLite(this._multiplierText.scale, 1 / 30, {x: 0.0}));

        tl.add([
            () => {
                this.updateMultiplierText();
                OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.SOUND_NAME_FS_MULTIPLIER_UP})
            },
            // wait 3 frames
            new TweenLite(this._multiplierText.scale, 3 / 30, {x: 0.0, y: 1.0})
        ]);
        tl.add(new TweenLite(this._multiplierText.scale, 1 / 30, {x: 0.2}));
        tl.add(new TweenLite(this._multiplierText.scale, 1 / 30, {x: 1.0}));
        tl.add(new TweenLite(this._multiplierText.scale, 2 / 30, {x: 0.9}));
        tl.add(new TweenLite(this._multiplierText.scale, 14 / 30, {x: 1.0}));
        tl.add(() => this.onLevelUpComplete());
        return tl;
    }
}